export default __webpack_public_path__ + "static/vg-4c507ebc698924eb248c9621378c6a30.svg";